import { CachedAuthClientDecorator } from "@/main/decorators/cached-auth-client-decorator/cached-auth-client-decorator";
import { getAuthClientInstance } from "@/main/singleton/auth-client-instance";
import { makeLocalStorage } from "../local-storage/local-storage-factory";
export var makeCachedAuthClient = function () {
    return new CachedAuthClientDecorator(getAuthClientInstance(), makeLocalStorage());
};
